// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","textDefault":"#808080","primary":"#56CCF2","primaryLight":"#ABEAFF","wrapper":"jWwMJRWkGNe8WYB3q9UmV","conditionMessage":"_1UgvukTiTM10FRXx2BDBm2","lecture":"_1xofrbd4ET4Ti94jkOvTfj","closeIcon":"_1nqRKO-7FNes4pXjIyjhXY"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Module/components/LectureStep.mod.css
// module id = 1722
// module chunks = 0